

import React, { useState } from 'react';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

const SearchCase = ({ onRowSelect, onClose }) => {

    const [searchResults, setSearchResults] = useState([]);

    const columns = [
        { field: 'caseNumber', headerName: 'Case Number', flex: 1, sortable: true, },
        { field: 'cpName', headerName: 'CP', flex: 1, sortable: true },
        { field: 'ncpName', headerName: 'NCP', flex: 1, sortable: true },
    ];

    // Simulate API call
    const mockResults = [
        { caseNumber: '1643', cpName: 'Woody Cane', ncpName: 'Candy Cane' },
        { caseNumber: '11223', cpName: 'TRACEY WILKINS', ncpName: 'TRAVIS CAMPBELL' },
        { caseNumber: '12313', cpName: 'Suzie Barber', ncpName: 'Hairy Barber' },
        { caseNumber: '1123', cpName: 'Steph Stevens', ncpName: 'Steve Stevens' },
        { caseNumber: '2212', cpName: 'Snowy Field', ncpName: 'Sandy Beach' },
        { caseNumber: '776654', cpName: 'Shary Tary', ncpName: 'Nary Tary' },
        { caseNumber: '2211', cpName: 'Sally Biggs', ncpName: 'Andy Biggs' },
        { caseNumber: '1234567', cpName: 'Ricky Bobby', ncpName: 'Cally Fornia' },
        { caseNumber: '12312', cpName: 'Pinto Bean', ncpName: 'Jelly Bean' },
        { caseNumber: '12354', cpName: 'Mary Blink', ncpName: 'Sam Blink' },
        { caseNumber: '112233', cpName: 'MARY THOMPSON', ncpName: 'BLAIR JAMES' },
        { caseNumber: '12316', cpName: 'Jim Sim', ncpName: 'Kim Sim' },
        { caseNumber: '9856', cpName: 'Jenny Mann', ncpName: 'HandyMann' },
    ];

  // Mock search function - replace with your actual API call
  const handleSearch = () => {
    
    setSearchResults(mockResults);
  };
  
  const handleRowClick = (params) => {
    onRowSelect(params.row);
    onClose();
  };

    return (
        <Box sx={{ p: 2 }}>

            {/* Add more search fields as needed */}

            <Button variant="contained" onClick={handleSearch}>
                Search
            </Button>

            <div style={{ height: 400, width: '100%' }}>
                <DataGridPremium
                    rows={searchResults}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    getRowId={(row) => `${row.caseNumber}-${row.rowIndex}`}
                    onRowClick={handleRowClick}
                />
            </div>
        </Box>
    );
};

export default SearchCase;